import client from '../httpClient';

const filestorageUpdateApi = (params) => {
  return client.put('/file-storages/', params);
};

export default filestorageUpdateApi;
